declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild  } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { ActorService } from '../../../../../services/actor.service';
import { ActorImageRequest } from '../../../../../models/actor/actor';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../../models/docs/doc.model';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
@Component({
  selector: 'ngbuploadactorimage',
  templateUrl: './ngbuploadactorimage.modal.html',
  styleUrls: ['./ngbuploadactorimage.modal.scss']
})

export class NgbdUploadActorImageModal implements OnInit {
  @Input() ActorCode;
  @Input() ActorImageCode;
  @Input() ActorImageFileExtension: string;
  @Input() ActorImageFile: string;
  //filesToUpload: Array<File>;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  file: File;
  fileList: FileList;

  FileExtension: string = "";
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  CurrentActorImageRequest: ActorImageRequest;


  @ViewChild('f') UploadActorImageForm: NgForm;
  public UploadActorImage: any;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.CurrentActorImageRequest = new ActorImageRequest();
    this.CurrentActorImageRequest.ActorCode = this.ActorCode;
    this.CurrentActorImageRequest.ActorImageCode = this.ActorImageCode;
    this.CurrentActorImageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  fileChange(event: any) {
    this.StartRefreshing();
    this.fileList = event.target.files;
    this.stopRefreshing();
  }


  onSubmit() {
  //  console.log('onSubmit------------------------------------>' )
    this.StartRefreshing();

    if (this.fileList != null && this.fileList.length > 0) {
      this.file = this.fileList[0];
      //console.log('this.file.type1--->' + this.file.size);
      if (this.file.type.indexOf('image') === -1) {


        alertFunctions.AlertParam('only images are allows');
        this.stopRefreshing();

      }
      else {
        let formData: FormData = new FormData();
        formData.append('userpic', this.file, this.file.name);
        this.FileExtension = this.file.name.substring(this.file.name.lastIndexOf("."));
        this.CurrentActorImageRequest.FileExtension = this.FileExtension;
        this.docservice.xUploadActorImage(formData, this.CurrentActorImageRequest)
          .subscribe(data => {
            // console.log('data------------------------------------>' + data)
            let a: number = data
            //// console.log('a------------------------------------>' + a)

           // alertFunctions.AlertParam('Upload Successfully...');
            this.tosterservice.ToasterSuccessAlertParam('Uploaded Successfully.....!');

            //  this.router.navigate(['nurse/profile']);
            this.activeModal.close();
            this.stopRefreshing();






          },
          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();



            }
            else {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();
            }
          }
          );
      }


    }
    else {
      alertFunctions.AlertParam('No files to Upload...!');
      this.stopRefreshing();
    }
  }

  public DownloadActorImage() {
   
    //this.CurrentDownloadFileRequestRequest.DBFileName = "4e51623b-e1d8-49bf-aa23-a4ef4e9d1dc0";
    //this.CurrentDownloadFileRequestRequest.folderType = "patientDocuments";
    //this.CurrentDownloadFileRequestRequest.ActorCode = 35631;
    //this.CurrentDownloadFileRequestRequest.FileExtension = '.pdf'
    //this.CurrentDownloadFileRequestRequest.FriendlyFileName='nareshtesting'
    //this.docservice.xDownloadDoc(this.CurrentDownloadFileRequestRequest)
     

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //fileChange(event: any) {
  //  this.StartRefreshing();
  //  // console.log('fileChange-->');
  //  let fileList: FileList = event.target.files;
  //  if (fileList.length > 0) {
  //    let file: File = fileList[0];
  //    let formData: FormData = new FormData();
  //    formData.append('userpic', file, file.name);
  //    this.FileExtension = file.name.substring(file.name.lastIndexOf("."));
  //    this.CurrentActorImageRequest.FileExtension = this.FileExtension;
  //    this.actorservice.xUploadActorImage(formData, this.CurrentActorImageRequest)
  //      .subscribe(data => {
  //        console.log('data------------------------------------>' + data)
  //        let a: number = data
  //        console.log('a------------------------------------>' + a)
  //        //if (a = 1) {

  //        //  alertFunctions.AlertParam('Upload Successfully...');
  //        //  this.activeModal.close();
  //        //  this.stopRefreshing();
  //        //}
  //        //else {
  //        //  alertFunctions.AlertParam("upload Failed...")
  //        //  this.stopRefreshing();
  //        //}
  //        alertFunctions.AlertParam('Upload Successfully...');
  //        this.activeModal.close();
  //        this.stopRefreshing();




  //      },
  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }
  //      );


  //  }

  //  //For Multipule Upload at a time
  //  //filesChange(fieldName: string, fileList: FileList) {
  //  //  // handle file changes
  //  //  const formData = new FormData();

  //  //  if (!fileList.length) return;

  //  //  // append the files to FormData
  //  //  Array
  //  //    .from(Array(fileList.length).keys())
  //  //    .map(x => {
  //  //      // this.FileExtension = fileList[x].name.substring(fileList[x].name.lastIndexOf("."));
  //  //      formData.append(fieldName, fileList[x], fileList[x].name);
  //  //    });

  //  //  // save it
  //  ////  this.save(formData);
  //  //}
  //  //////////////////////////////////////////////

  //  //<input type="file" multiple
  //  //[name] = "uploadFieldName"(change) = "filesChange($event.target.name, $event.target.files)"
  //  //[disabled] = "currentStatus === STATUS_SAVING" accept= "image/*" #photos >

  //  /////////////////////////////////////////
  //}
}
